export default __webpack_public_path__ + "static/media/EAST3060.34I-39038_-22983_0.e6490187.jpg";